export const PATH = Object.freeze({
  ROOT: '/',
  COUPON: '/coupon',
  COUPON_OLD: '/coupon_old',
  GET_REWARDS: '/get-rewards',
});

const deployEnv = process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'prod' : 'alpha';
export const isAlpha = deployEnv === 'alpha';

const ALPHA_AUTOPASS_URL = 'https://alpha.pklotcorp.com';
const PROD_AUTOPASS_URL = '"https://autopass.xyz';

const ALPHA_AMPLITUDE_KEY = 'f52218b3ea823cab4a8443f2743c9b28';
const PROD_AMPLITUDE_KEY = 'e4d208b9a0da569e9e1b838c174723db';

const ALPHA_API_URL = 'https://api-alpha.pklotcorp.com/';
const PROD_API_URL = 'https://api.autopass.xyz/';

const ALPHA_BRANCH_KEY = 'key_test_klrTPRwqxvfNYduMkprH1lkdzDnue52B';
const PROD_BRANCH_KEY = 'key_live_cpsPJIAwyxmR0eyKceDPQdlfExdAbWZn';

const ALPHA_MAINTENANCE_CONFIG_URL = 'https://maintenance-alpha.pklotcorp.com/config.json';
const PROD_MAINTENANCE_CONFIG_URL = 'https://maintenance.autopass.xyz/config.json';

export const API_URL = isAlpha ? ALPHA_API_URL : PROD_API_URL;
export const AUTOPASS_URL = isAlpha ? ALPHA_AUTOPASS_URL : PROD_AUTOPASS_URL;
export const AMPLITUDE_KEY = isAlpha ? ALPHA_AMPLITUDE_KEY : PROD_AMPLITUDE_KEY;
export const BRANCH_KEY = isAlpha ? ALPHA_BRANCH_KEY : PROD_BRANCH_KEY;
export const MAINTENANCE_CONFIG_URL = isAlpha ? ALPHA_MAINTENANCE_CONFIG_URL : PROD_MAINTENANCE_CONFIG_URL;

export const VALIDATE_STATUS = Object.freeze({
  INIT: 'init',
  VALID: 'valid',
  INVALID: 'invalid',
});
